// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"b5400676","355":"c560be7e","460":"23f2fb4b","544":"096ae07e","617":"f2c1c1ad","620":"51c07454"}[chunkId] + ".chunk.js";
};